"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAPIHost = void 0;
exports.airRequest = airRequest;
const errors_1 = require("@air/errors");
const server_sdk_1 = require("@air/server-sdk");
const shared_utils_1 = require("@air/shared-utils");
const auth_1 = require("./auth");
const config_1 = require("./config");
const error_1 = require("./error");
const success_1 = require("./success");
const { getDebugId, getDefaultUserAgent, getShortUrlToken, getBaseUrl, getRequestController, } = config_1.config;
const JsonMethods = new Set(['POST', 'DELETE', 'PATCH', 'PUT']);
// Gets api host, should only be called after config.configure has been called
const getAPIHost = () => getBaseUrl();
exports.getAPIHost = getAPIHost;
function airRequest(endpointType_1) {
    return __awaiter(this, arguments, void 0, function* (endpointType, { endpoint = '', method = 'GET', authorized = true, body, boardContext = '', shortUrlProtection, sameOrigin = false, workspaceId, returnErrors = false, } = {}) {
        var _a, _b;
        if (typeof endpointType !== 'string') {
            method = endpointType.method.toUpperCase();
        }
        // don't send X-Air-Short-Url-Token by default
        const headers = {
            Authorization: '',
            Accept: '',
            'Content-Type': '',
            [shared_utils_1.BOARD_CONTEXT_HEADER]: '',
        };
        const userAgent = getDefaultUserAgent();
        if (userAgent) {
            headers['User-Agent'] = userAgent;
        }
        const debug = getDebugId();
        if (authorized === true || authorized === 'optional') {
            try {
                headers.Authorization = yield auth_1.Auth.getJWTToken();
            }
            catch (error) {
                // if `authorized` is `optional`, make the request without the auth header
                if (authorized === true) {
                    const airror = new errors_1.Airror(errors_1.NO_AUTH_HEADER);
                    (0, error_1.handleErrorEvent)(airror);
                    throw error;
                }
            }
        }
        if (shortUrlProtection) {
            const token = getShortUrlToken(shortUrlProtection.id);
            if (token) {
                headers[shared_utils_1.SHORT_URL_TOKEN_HEADER] = token;
            }
        }
        if (JsonMethods.has(method)) {
            headers.Accept = 'application/json';
            headers['Content-Type'] = 'application/json';
        }
        if (boardContext && boardContext.length) {
            if (typeof boardContext === 'string') {
                headers[shared_utils_1.BOARD_CONTEXT_HEADER] = boardContext.trim();
            }
            else if (Array.isArray(boardContext)) {
                headers[shared_utils_1.BOARD_CONTEXT_HEADER] = boardContext.join();
            }
        }
        const workspaceString = workspaceId ? `workspaces/${workspaceId}/` : '';
        const baseUrl = getBaseUrl();
        const url = typeof endpointType === 'string'
            ? `${baseUrl}/${workspaceString}${endpointType}/${endpoint}`
            : endpointType.path;
        if (debug) {
            console.log(`airRequest (${debug}): Making fetch with:\n\n   url:`, url, `\n\n   method: `, method, `\n\n   headers: `, headers, `\n\n   body: `, body, `\n\n`);
        }
        const requestController = getRequestController === null || getRequestController === void 0 ? void 0 : getRequestController({ method, headers });
        const _fetch = (...args) => fetch(...args)
            .then((response) => {
            if (response.ok) {
                (0, success_1.handleSuccessEvent)(response);
            }
            return response;
        })
            .catch((error) => {
            if (debug) {
                console.log(`airRequest (${debug}): Error on fetch: `, error);
            }
            const airror = new errors_1.Airror(errors_1.FAILED_TO_FETCH);
            (0, error_1.handleErrorEvent)(airror);
            throw airror;
        })
            .finally(() => {
            if (requestController) {
                requestController.onFinished();
            }
        });
        try {
            if (typeof endpointType === 'string') {
                const response = yield _fetch(url, {
                    method,
                    headers,
                    signal: (_a = requestController === null || requestController === void 0 ? void 0 : requestController.abortController) === null || _a === void 0 ? void 0 : _a.signal,
                    mode: sameOrigin ? 'same-origin' : 'cors',
                    body: body ? JSON.stringify(body) : undefined,
                });
                const responseBody = yield (0, server_sdk_1.parseResponseBody)(response);
                if (!response.ok) {
                    const airror = (0, server_sdk_1.parseAirrorResponse)(Object.assign(Object.assign({}, response), { body: responseBody }));
                    if (debug) {
                        console.log(`airRequest (${debug}): Response not ok: `, responseBody);
                    }
                    (0, error_1.handleErrorEvent)(airror);
                    if (!returnErrors) {
                        throw airror;
                    }
                    return airror;
                }
                if (debug) {
                    console.log(`airRequest (${debug}): fetch success: `, responseBody);
                }
                return responseBody;
            }
            const response = yield endpointType(Object.assign({ workspaceId, shortId: shortUrlProtection === null || shortUrlProtection === void 0 ? void 0 : shortUrlProtection.id }, body), {
                host: baseUrl || undefined,
                fetch: _fetch,
                headers,
                mode: sameOrigin ? 'same-origin' : 'cors',
                signal: (_b = requestController === null || requestController === void 0 ? void 0 : requestController.abortController) === null || _b === void 0 ? void 0 : _b.signal,
            });
            if (response instanceof errors_1.Airror) {
                if (debug) {
                    console.log(`airRequest (${debug}): Response not ok: `, response.json);
                }
                (0, error_1.handleErrorEvent)(response);
                if (!returnErrors) {
                    throw response;
                }
            }
            else if (debug) {
                console.log(`airRequest (${debug}): fetch success: `, response);
            }
            return response;
        }
        catch (error) {
            // TODO: revisit this by making all sdk methods typed with possible airrors
            // even if they did not originate from the server so that a throw is not necessary
            // https://linear.app/air/issue/ENG-50/update-sdk-to-be-more-intelligent-with-returning-andor-throwing-errors
            if (error instanceof errors_1.Airror ||
                error instanceof Error ||
                typeof error === 'string') {
                (0, error_1.handleErrorEvent)(error);
            }
            if (debug) {
                console.log('airRequest: error thrown utilizing server-sdk', error);
            }
            throw error;
        }
    });
}
//# sourceMappingURL=request.js.map